import React, { useEffect, useState } from "react";
import { Modal, Button, Icon, Checkbox } from 'antd';
import styled from 'styled-components';
import { GetDynamicPage } from "../../infra/requests/BaseRequests";
import { SpinLoading } from "../../styles/BasicStyles";
import { TranslateFromObject } from "../../infra/services/translations/AvailableTranslations";
import { AgendaType } from "./AgendaPage";
import { LinkAcceptPolicy } from "../../components/YearView/CalendarStyles";
import { Content } from "./InterestPolicyModal";

export const StyledDraftJS = styled.div`
  display: inline-block;
  width: 100%;
  height: calc(100vh - 250px);
  padding: 24px;
  overflow: auto;
  text-align: left;
  white-space: pre-line;
`;

let WaitingDatesPolicyModal = ({ openModal, agendaType, initialValues, saveModal, closeModal, translate, activeLanguage }) => {

  const [content, setContent] = useState({});
  const [loading, toogleLoading] = useState(true);

  const [acceptedWaitingPolicy, setAcceptedWaitingPolicy] = useState(false);

  useEffect(() => {
    if (initialValues?.acceptedWaitingPolicy) {
      setAcceptedWaitingPolicy(initialValues.acceptedWaitingPolicy);
    }
  }, [initialValues])

  useEffect(() => {
    async function getContent() {
      toogleLoading(true);
      const pageId = '6516c9d5c8406436b0cd6677';
      const { data } = await GetDynamicPage(pageId);
      setContent(data);
      toogleLoading(false);
    }
    getContent();
    document.body.style.overflowY = 'auto';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      visible={openModal}
      title={translate('TERMS_CONDITIONS_WD')}
      maskClosable
      onCancel={closeModal}
      className="policy-modal"
      footer={initialValues?.acceptedWaitingPolicy
        ? [
          <Button
            loading={loading}
            type='default'
            onClick={() => closeModal()}>
            {translate('CLOSE')}
          </Button>
        ]
        : [
          <Button
            key='submit'
            loading={loading}
            type='default'
            onClick={() => closeModal()}>
            {translate('CANCEL')}
          </Button>,
          <Button
            key='submit'
            loading={loading}
            type='primary'
            disabled={!acceptedWaitingPolicy}
            onClick={() => saveModal(acceptedWaitingPolicy)}>
            {translate('SAVE')}
          </Button>
        ]}
    >
      {loading
        ? <SpinLoading />
        : <Content>
          <StyledDraftJS
            dangerouslySetInnerHTML={{
              __html: TranslateFromObject(content?.description || '', activeLanguage.code)
            }}
          />
          {agendaType === AgendaType.WAITING_DATE && <Checkbox
            checked={acceptedWaitingPolicy}
            disabled={initialValues?.acceptedWaitingPolicy}
            onChange={(e) => setAcceptedWaitingPolicy(e?.target?.checked)}>
            <LinkAcceptPolicy>{translate('ACCEPT_WAITING_POLICY')}</LinkAcceptPolicy>
          </Checkbox>}
        </Content>
      }
    </Modal >
  );
};

export default WaitingDatesPolicyModal;